var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.215 4.074s-7.003 0-8.76.457a2.9 2.9 0 0 0-1.98 1.993C1.02 8.28 1.02 11.92 1.02 11.92s0 3.654.456 5.384a2.85 2.85 0 0 0 1.98 1.98c1.77.47 8.76.47 8.76.47s7.017 0 8.775-.457a2.78 2.78 0 0 0 1.965-1.979c.47-1.744.47-5.384.47-5.384s.015-3.654-.47-5.411a2.77 2.77 0 0 0-1.965-1.966c-1.758-.484-8.775-.484-8.775-.484M9.987 8.558l5.827 3.363-5.827 3.35z"
  })));
};
export default SvgIconYoutube;